<template>
  <span v-if="!active" class="text-xs px-2 py-0.5 font-bold bg-red-100 text-red-600 rounded">
    <!--    {{ active }}-->
    Não
  </span>
  <span v-else class="text-xs px-2 py-0.5 font-bold bg-green-100 text-green-600 rounded">
    <!--    {{ active }}-->
    Sim
  </span>
</template>

<script>
export default {
  props: {
    active: Boolean,
  },
}
</script>
